exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-marketing__title {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.25rem;\n}\n\n.explore-marketing__description {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n}\n\n.explore-marketing {\n  align-self: center;\n  text-align: center;\n  padding: 32px;\n  max-width: 350px;\n}\n\n.explore-marketing__title {\n  margin-bottom: 8px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/components/startingPoints/marketing.scss
// module id = 381
// module chunks = 0